import styled from 'styled-components';

export const Header = styled.div`
  color: #4a4a4a;
  font-size: 20px;
  font-weight: 500;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Body = styled.div`
  display: flex;
  padding: 8px 8px 0 24px;
  flex-direction: column;
  gap: 16px;

  color: rgba(0, 0, 0, 0.88);
  line-height: 22px;
`;

export const Footer = styled.div`
  padding: 16px 8px;

  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
